import { SpaPackageListingType } from 'shared-types/SpaPackage';

export const markUnavailableSpaPackages = (
  spaPackagesAll: SpaPackageListingType[],
  spaPackages: SpaPackageListingType[]
): SpaPackageListingType[] =>
  spaPackagesAll.map((sp) => ({ ...sp, unAvailable: !spaPackages.find((x) => x.id === sp.id) }));
